import React from 'react';
import { Modal } from '@components-react/Modal/Modal';
import * as Types from './quotesTypes';

interface RequestAQuoteModalProps {
  variant: Types.Variant;
  dismissModal: () => void
}
export const RequestAQuoteModal = ({ variant, dismissModal }: RequestAQuoteModalProps) => {
  return (
    <Modal
      title="Toegevoegd aan offerte aanvraag"
      onModalClose={dismissModal}
      buttons={
        [
          {
            type: 'outline-primary',
            label: 'Verder winkelen',
            onClick: dismissModal
          },
          {
            type: 'primary',
            label: 'Offerte aanvragen',
            onClick: () => {
              window.location.href = '/offerte-aanvragen';
            }
          }
        ]}
    >
      <div
        className="request-a-quote-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="requestAQuoteModalTitle"
      >
        <h2 className="h3">{variant.title}</h2>
        <span className="text-muted">Art.: {variant.code}</span>
      </div>
    </Modal>
  );
};
